import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";
import RelatedGuides from "./RelatedGuides";

export default function Deducere100Page() {
  return (
    <>
      <Seo {...seoFromPublicPage("/deducere-100-combustibil")} />
      <ArticleLayout
        eyebrow="Fiscalitate auto"
        title="Deducere 100% combustibil: condițiile pentru TVA și impozit"
        lead="Pentru firmele cu vehicule sub 3,5 tone, regula implicită este deducerea de 50%. Trecerea la 100% necesită utilizare exclusiv economică și o foaie de parcurs corect întocmită. Iată exact ce verifică ANAF."
      >
        <h2>Regula generală: 50% sau 100%</h2>
        <p>
          Conform <strong>art. 298 alin. (1)</strong> din Codul Fiscal (TVA) și
          <strong> art. 25 alin. (3) lit. l)</strong> (impozit pe profit), dreptul de
          deducere pentru vehicule rutiere motorizate sub 3.500 kg și cu maxim 9 scaune
          este limitat la <strong>50%</strong>, cu excepția situațiilor expres prevăzute
          de lege.
        </p>
        <p>
          Limitarea se aplică <strong>tuturor</strong> cheltuielilor legate de vehicul:
          combustibil, întreținere, reparații, asigurări, rovinietă, parcare, amortizare,
          chirie/leasing.
        </p>

        <h2>Când deduci 100%</h2>
        <p>Există două mari căi:</p>

        <h3>1. Vehicule exceptate prin lege</h3>
        <p>
          Pentru următoarele categorii, deducerea integrală se aplică <strong>fără foaie
          de parcurs</strong>:
        </p>
        <ul>
          <li>vehicule peste 3.500 kg sau cu peste 9 scaune (incluzând șoferul)</li>
          <li>vehicule pentru servicii de urgență, pază sau curierat</li>
          <li>vehicule folosite de agenți de vânzări și de achiziții</li>
          <li>vehicule pentru transport de persoane cu plata (taximetrie)</li>
          <li>vehicule pentru școli de șoferi sau test-drive</li>
          <li>vehicule pentru intervenție, service, reparații</li>
        </ul>
        <p>
          Autoutilitara ușoară nu intră în lista de mai sus doar pentru că pe talon scrie
          N1. Sub 3.500 kg și cu cel mult 9 locuri, urmează aceeași regulă ca
          autoturismul. Criteriile sunt în{" "}
          <Link to="/autoutilitara-vs-autoturism-deductibilitate">
            articolul autoutilitară vs autoturism
          </Link>
          .
        </p>

        <h3>2. Utilizare exclusiv în scopul activității economice</h3>
        <p>
          Pentru orice alt vehicul (autoturism clasic pe firmă), deducerea de 100% este
          posibilă <strong>doar dacă</strong>:
        </p>
        <ul>
          <li>există <strong>foaie de parcurs</strong> completată corect pentru fiecare deplasare;</li>
          <li>
            există un{" "}
            <Link to="/regulament-intern-autoturism">
              <strong>regulament intern</strong>
            </Link>{" "}
            care interzice folosirea în scop personal;
          </li>
          <li>cheltuielile sunt susținute cu facturi, bonuri și extrase de cont.</li>
        </ul>
        <div className="article-doc__callout">
          <strong>Detaliu legal</strong>
          <p>
            Justificarea utilizării se face pe baza foii de parcurs care trebuie să conțină
            minimum: categoria vehiculului, scopul și locul deplasării, kilometrii parcurși
            și norma proprie de consum (pct. 68 alin. (2) Norme metodologice art. 298).
            <Link to="/ghid-foaie-parcurs-anaf"> Vezi ghidul complet</Link>.
          </p>
        </div>

        <h2>Exemplu de calcul: 50% vs 100% pentru un vehicul</h2>
        <p>
          Presupunem un autoturism cu următoarele cheltuieli lunare:
        </p>
        <ul>
          <li>Combustibil: 800 lei + 152 lei TVA = 952 lei</li>
          <li>Service / piese: 300 lei + 57 lei TVA = 357 lei</li>
          <li>Asigurări (RCA + CASCO, lunar): 200 lei (fără TVA)</li>
          <li><strong>Total lunar: 1.509 lei (din care TVA 209 lei)</strong></li>
        </ul>
        <div className="article-doc__table-wrap">
          <table className="article-doc__table">
            <thead>
              <tr>
                <th>Scenariu</th>
                <th>TVA recuperat</th>
                <th>Cheltuială deductibilă</th>
                <th>Impozit profit economisit (16%)</th>
                <th>Total beneficiu lunar</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>50% (fără foaie)</td>
                <td>104,50 lei</td>
                <td>650 lei</td>
                <td>104 lei</td>
                <td>~208,50 lei</td>
              </tr>
              <tr>
                <td>100% (cu foaie)</td>
                <td>209 lei</td>
                <td>1.300 lei</td>
                <td>208 lei</td>
                <td>~417 lei</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Diferența: <strong>~208 lei/lună per vehicul</strong>, sau peste 2.500 lei/an.
          Pentru o flotă de 3 vehicule, beneficiul anual al deducerii de 100% trece de
          7.500 lei.
        </p>

        <h2>Ce verifică ANAF la un control</h2>
        <p>
          Inspectorii nu se uită doar la prezența foilor de parcurs. Verifică
          <strong> coerența</strong> între:
        </p>
        <ol>
          <li>
            <strong>Km de pe foi vs. km de pe odometru</strong> — sumă lunară foi ≈
            diferență odometru.
          </li>
          <li>
            <strong>Litri consumați vs. alimentări</strong> — total litri din bonuri ≈ km
            × norma de consum + ajustări rezervor.
          </li>
          <li>
            <strong>Scopul deplasării vs. activitatea reală</strong> — „vizită client SC X"
            trebuie să poată fi corelat cu o factură, contract sau ofertă.
          </li>
          <li>
            <strong>Stocul de combustibil</strong> — rezervor inițial + alimentări −
            consum = rezervor final, fără depășiri de capacitate sau valori negative.
          </li>
          <li>
            <strong>Regulamentul intern</strong> și politica de utilizare a vehiculelor.
          </li>
        </ol>

        <h2>Riscul în cifre: cât pierzi la un control nereușit</h2>
        <div className="article-doc__callout article-doc__callout--warning">
          <strong>Penalitatea totală</strong>
          <p>
            Dacă ANAF refuză deducerea 100% retroactiv pe 2 ani, pentru 3 vehicule cu
            cheltuieli de 1.500 lei/lună, recalcularea înseamnă:
          </p>
          <p>
            ~5.000 lei TVA + 5.000 lei impozit profit + ~3.000 lei dobânzi și penalități
            de întârziere = <strong>peste 13.000 lei</strong>.
          </p>
        </div>

        <h2>Cum reduci riscul în practică</h2>
        <ul>
          <li>
            <strong>Completează foile lunar, nu anual.</strong> Coerența cu bonurile de
            combustibil contemporane este mult mai ușor de demonstrat.
          </li>
          <li>
            <strong>Folosește o aplicație care validează coerența</strong> kilometri–consum–rezervor
            în timpul completării — astfel încât inconsistențele apar și se rezolvă imediat.
          </li>
          <li>
            <strong>Păstrează regulamentul intern</strong> semnat de angajații care
            folosesc vehiculul.
          </li>
          <li>
            <strong>Reconciliază lunar</strong> totalul kilometrilor cu odometrul și
            totalul litrilor cu fișa de combustibil.
          </li>
        </ul>

        <h2>Concluzie</h2>
        <p>
          Deducerea de 100% nu este o opțiune „periculoasă", ci una <strong>legitimă</strong>
          condiționată de documente. În contextul actual al costurilor auto, renunțarea
          la 100% înseamnă bani lăsați pe masă lună de lună. Cheia este disciplina la
          completarea foilor — și aici tehnologia poate scoate eroarea umană din ecuație.
        </p>
        <RelatedGuides currentPath="/deducere-100-combustibil" />
      </ArticleLayout>
    </>
  );
}
